import { useTranslation } from 'react-i18next';

import { InputFieldRadio } from './InputFieldRadio';

export const YesNoInput = () => {
  const { t } = useTranslation(['settings']);

  return (
    <>
      <InputFieldRadio value="yes">{t('settings:general.customConditions.wizard.common_answers.yes')}</InputFieldRadio>

      <InputFieldRadio value="no">{t('settings:general.customConditions.wizard.common_answers.no')}</InputFieldRadio>
    </>
  );
};
